import { render, staticRenderFns } from "./VisaoInovacao.vue?vue&type=template&id=58f3def5&scoped=true&lang=pug"
import script from "./VisaoInovacao.vue?vue&type=script&lang=js"
export * from "./VisaoInovacao.vue?vue&type=script&lang=js"
import style0 from "./VisaoInovacao.vue?vue&type=style&index=0&id=58f3def5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f3def5",
  null
  
)

export default component.exports